import { docodeHexResponse } from "../_common/common.utils";
import GeneralActionTypes from "./general.types";

const INITIAL_STATE = {
  isDetailsEdit: false,
  isOffcanvasOpen: false,
  fetchCountryListResp: null,
  fetchCountryListArr: [],
  fetchCountryStateListResponse: null,
  fetchCountryStateArr: [],
  fetchStateCityListResponse: null,
  fetchStateCityArr: [],
};
const generalReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** *************** ISEDIT DETAILS ******************* */
    case GeneralActionTypes.IS_EDIT_DETAILS_START:
      return { ...state, isDetailsEdit: action.payload };

    /** *************** OFF CANVAS DETAILS ******************* */
    case GeneralActionTypes.IS_OPEN_OFFCANVAS_START:
      return { ...state, isOffcanvasOpen: action.payload };

    /** ***************** FETCH BRANCH  LIST DETAILS START *********************** */
    case GeneralActionTypes.FETCH_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        fetchCountryListResp: action.payload,
        fetchCountryListArr: docodeHexResponse(
          action.payload,
          "GetCountryListKey",
        ),
      };
    case GeneralActionTypes.FETCH_COUNTRY_LIST_FAILURE:
      return {
        ...state,
        fetchCountryListResp: action.payload,
        fetchCountryListArr: [],
      };

    case GeneralActionTypes.FETCH_COUNTRY_LIST_RESPONSE_CHANGED:
      return { ...state, fetchCountryListResp: null };
    /** ***************** FETCH BRANCH  LIST DETAILS START END *********************** */

    /** ***************** FETCH COUNTRY LIST STATE START *********************** */
    case GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_SUCCESS:
      return {
        ...state,
        fetchCountryStateListResponse: action.payload,
        fetchCountryStateArr: docodeHexResponse(
          action.payload,
          "CountryStateListGetKey",
        ),
      };
    case GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_FAILURE:
      return {
        ...state,
        fetchCountryStateListResponse: action.payload,
        fetchCountryStateArr: [],
      };

    case GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_RESPONSE_CHANGED:
      return { ...state, fetchCountryStateListResponse: null };
    /** ***************** FETCH COUNTRY LIST STATE  END *********************** */

    /** ***************** FETCH STATE CITY LILST DETAILS START *********************** */

    case GeneralActionTypes.FETCH_STATE_CITY_LIST_SUCCESS:
      return {
        ...state,
        fetchStateCityListResponse: action.payload,
        fetchStateCityArr: docodeHexResponse(
          action.payload,
          "StateCityListGetKey",
        ),
      };
    case GeneralActionTypes.FETCH_STATE_CITY_LIST_FAILURE:
      return {
        ...state,
        fetchStateCityListResponse: action.payload,
        fetchStateCityArr: [],
      };

    case GeneralActionTypes.FETCH_STATE_CITY_LIST_RESPONSE_CHANGED:
      return { ...state, fetchStateCityListResponse: null };

    /** ***************** FETCH STATE CITY LIST DETAILS END *********************** */

    default:
      return state;
  }
};
export default generalReducer;
